import React from 'react';
import { useTranslation } from 'react-i18next';
import '../../../../translations/i18n';
import * as utils from '../../../../utils/OrderUtils';

function DepositsCopy({
  styles,
  currency,
  amount,
  cutOffDate,
  refundable,
  accommodationResortId,
}) {
  const { t } = useTranslation('common');
  // World Disney World resort ID
  const WDWResortId = 481;

  let depositDeadline = new Date(cutOffDate);
  depositDeadline = new Intl.DateTimeFormat('en-GB').format(depositDeadline);

  switch (accommodationResortId) {
    case WDWResortId:
      return (
        <div className={styles.depositsModalContent}>
          <p>{t('payment.deposits-byline')}</p>
          <h4 className={styles.depositsSpacer}>{t('payment.deposits-subheading')}</h4>
          <div className={styles.depositsModalList}>
            <div className={styles.depositsModalListRow}>
              <div className={styles.depositsNumber}>1</div>
              <div className={styles.depositsMeta}>
                <h4>
                  {t('payment.non-refundable-deposits-title-1', {
                    amount: utils.formatPrice(currency, amount),
                  })}
                </h4>
                <p>
                  {t('payment.non-refundable-deposits-content-1.standard')}
                  {!refundable && t('payment.non-refundable-deposits-content-1.non-refundable', { amount: utils.formatPrice(currency, amount) })}
                </p>
              </div>
            </div>
            <div className={styles.depositsModalListRow}>
              <div className={styles.depositsNumber}>2</div>
              <div className={styles.depositsMeta}>
                <h4>{t('payment.non-refundable-deposits-title-2')}</h4>
                <p>{t('payment.non-refundable-deposits-content-2')}</p>
              </div>
            </div>
            <div className={styles.depositsModalListRow}>
              <div className={styles.depositsNumber}>3</div>
              <div className={styles.depositsMeta}>
                <h4>{t('payment.non-refundable-deposits-title-3')}</h4>
                <p>{t('payment.non-refundable-deposits-content-3')}</p>
              </div>
            </div>
            <div className={styles.depositsModalListRow}>
              <div className={styles.depositsNumber}>4</div>
              <div className={styles.depositsMeta}>
                <h4>{t('payment.non-refundable-deposits-title-4')}</h4>
                <p>
                  {t('payment.non-refundable-deposits-content-4', { date: utils.formatDate(depositDeadline) })}
                </p>
              </div>
            </div>
            <div className={styles.depositsModalListRow}>
              <div className={styles.depositsNumber}>5</div>
              <div className={styles.depositsMeta}>
                <h4>{t('payment.non-refundable-deposits-title-5')}</h4>
                <p>{t('payment.non-refundable-deposits-content-5')}</p>
              </div>
            </div>
            <div className={styles.depositsModalListRow}>
              <div className={styles.depositsNumber}>6</div>
              <div className={styles.depositsMeta}>
                <h4>{t('payment.non-refundable-deposits-title-6')}</h4>
              </div>
            </div>
          </div>
        </div>
      );
    default:
      return (
        <div className={styles.depositsModalContent}>
          <p>{t('payment.deposits-byline')}</p>
          <h4 className={styles.depositsSpacer}>{t('payment.deposits-subheading')}</h4>
          <div className={styles.depositsModalList}>
            <div className={styles.depositsModalListRow}>
              <div className={styles.depositsNumber}>1</div>
              <div className={styles.depositsMeta}>
                <h4>
                  {t('payment.deposits-title-1', { amount: utils.formatPrice(currency, amount) })}
                </h4>
                <p>{t('payment.deposits-content-1')}</p>
              </div>
            </div>
            <div className={styles.depositsModalListRow}>
              <div className={styles.depositsNumber}>2</div>
              <div className={styles.depositsMeta}>
                <h4>{t('payment.deposits-title-2')}</h4>
                <p>{t('payment.deposits-content-2')}</p>
              </div>
            </div>
            <div className={styles.depositsModalListRow}>
              <div className={styles.depositsNumber}>3</div>
              <div className={styles.depositsMeta}>
                <h4>{t('payment.deposits-title-3')}</h4>
                <p data-testid="payment.deposits-content-3">
                  {t('payment.deposits-content-3', { date: utils.formatDate(depositDeadline) })}
                </p>
              </div>
            </div>
            <div className={styles.depositsModalListRow}>
              <div className={styles.depositsNumber}>4</div>
              <div className={styles.depositsMeta}>
                <h4>{t('payment.deposits-title-4')}</h4>
                <p>{t('payment.deposits-content-4')}</p>
              </div>
            </div>
          </div>
        </div>
      );
  }
}

export default DepositsCopy;
